import { services } from "../../util/Constants";

interface Props {
    className?: string;
}

export default function OurServices({ className = "" }: Props) {
    return (
        <section className={`${className}`}>
            <div className="z-10 mx-auto flex max-w-7xl flex-col">
                <div className="mb-5 flex items-center gap-3">
                    <div className="h-px w-12 bg-web-secondary" />
                    <span className="text-xs font-medium uppercase tracking-wider text-web-secondary">
                        What we offer
                    </span>
                </div>

                <h2 className="max-w-3xl text-4xl font-bold leading-tight md:text-5xl">
                    Everything you need to{" "}
                    <span className="text-web-primary">
                        scale conversations.
                    </span>
                </h2>


                <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {services.map((item) => {
                        return (
                            <div
                                key={item.id}
                                className="flex hover:shadow-web-glow flex-col gap-4 rounded-[20px] border border-[#080A0D]/[0.12] bg-white/70 p-7 backdrop-blur-[6px]"
                            >
                                <div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-web-primary/20 bg-web-primary/10">
                                    <img
                                        src={item.icon}
                                        alt={item.heading}
                                        className=" object-contain"
                                    />
                                </div>

                                <h3 className="text-lg font-semibold text-black">
                                    {item.heading}
                                </h3>

                                <p className="text-sm leading-6 text-text-secondary">
                                    {item.description}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}